import React, { useRef, useEffect } from 'react';
import Typography from '@mui/material/Typography';
import { makeStyles } from '~/tools/makeStyles';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles((theme) => ({
  root: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  },
  messageContainer: {
    textAlign: 'center',
    marginBottom: 16,
  },
  message: {
    fontSize: 32,
    color: theme.palette.mainaccent,
  },
}));

const ThankYouPage = () => {
  const styles = useStyles();
  const { t } = useTranslation();

  const announceRef = useRef(null);

  useEffect(() => {
    if (announceRef?.current) {
      announceRef.current.focus();
    }
  }, []);

  return (
    <div className={styles.root} role="main" id="main">
      <div className={styles.messageContainer}>
        <Typography tabIndex={0} ref={announceRef} variant="h1" className={styles.message}>
          {t('survey.thanks.greeting')}
        </Typography>
        <Typography tabIndex={0}>{t('survey.thanks.message')}</Typography>
      </div>
    </div>
  );
};

export default ThankYouPage;
